import { createFeatureSelector, createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';
import { DataResponse } from '@fcom/common/interfaces';

import { CORPORATE_FEATURE_KEY, CorporateFeatureState, CorporateState } from '../constants';

const _corporateState = createFeatureSelector<CorporateFeatureState, CorporateState>(CORPORATE_FEATURE_KEY);

const _reportsState = createSelector(_corporateState, (state: CorporateState) => state.reports);

const _selectReport = (corporateId: string, dateRange: string) =>
  createSelector(_reportsState, (reports) => reports?.[corporateId]?.[dateRange]);

export const selectReport = (
  corporateId: string,
  dateRange: string
): StateSelector<CorporateFeatureState, DataResponse | string> => select(_selectReport(corporateId, dateRange));
